module.exports = __webpack_public_path__ + "static/media/loading5.2dffd3f4.gif";